<template>
  <div>
    <svg
      v-if="state.width < 1800"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 152"
      class="course-page-svg"      
    >
      <defs>
        <clipPath id="clippath">
          <rect
            class="cls-1"
            width="1920"
            height="152"
          />
        </clipPath>
      </defs>
      <g id="Section7_-_Call-to-Action">
        <g class="cls-2">
          <g id="Path_829">
            <path
              class="cls-4"
              fill="red"
              d="m-22.25,147.14V-4h2162.26c-3.89,3.46-10.28,8.7-19.55,14.98-11.08,7.5-23.92,14.93-38.17,22.08-17.82,8.94-37.91,17.46-59.71,25.33-55.5,20.03-122.26,36-198.42,47.45-22.02,3.31-45.13,6.28-68.69,8.83-24.8,2.68-50.78,4.97-77.21,6.81-27.73,1.92-56.73,3.4-86.19,4.38-30.77,1.03-62.91,1.55-95.51,1.55h-.1c-43.66,0-89.56-.94-136.41-2.78-49.23-1.93-100.84-4.92-153.4-8.88-47.15-3.55-94.63-6.67-141.13-9.28-44.53-2.5-89.34-4.59-133.2-6.22-81.73-3.03-163.19-4.57-242.1-4.57-55.33,0-110.53.76-164.05,2.25-48.66,1.36-97.03,3.35-143.77,5.93-78.73,4.34-154.35,10.4-224.75,18-27.67,2.99-54.58,6.22-80.01,9.62-20.34,2.72-39.78,5.54-57.78,8.4-21.05,3.34-35.23,5.95-42.1,7.26Z"
            />
          </g>
        </g>
      </g>
    </svg>
    <svg 
      v-else
      id="Layer_1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlns:xlink="http://www.w3.org/1999/xlink" 
      viewBox="0 0 4000 152"
      class="course-page-svg"
    >
      <defs>
        <clipPath id="clippath">
          <rect 
            class="cls-1" 
            width="4000" 
            height="152"
          />
        </clipPath>
      </defs>
      <g id="Section7_-_Call-to-Action">
        <g class="cls-2">
          <path 
            class="cls-4"
            fill="red" 
            d="m-46.35,145.14V-6h4504.71c-8.1,3.46-21.42,8.7-40.72,14.98-23.08,7.5-49.83,14.93-79.53,22.08-37.13,8.94-78.98,17.46-124.39,25.33-115.62,20.03-254.7,36-413.38,47.45-45.87,3.31-94.01,6.28-143.09,8.83-51.66,2.68-105.78,4.97-160.86,6.81-57.76,1.92-118.18,3.4-179.56,4.38-64.1,1.03-131.05,1.55-198.98,1.55h-.22c-90.97,0-186.58-.94-284.19-2.78-102.56-1.93-210.09-4.92-319.59-8.88-98.22-3.55-197.15-6.67-294.03-9.28-92.76-2.5-186.13-4.59-277.5-6.22-170.28-3.03-339.98-4.57-504.38-4.57-115.28,0-230.27.76-341.77,2.25-101.37,1.36-202.15,3.35-299.52,5.93-164.02,4.34-321.56,10.4-468.23,18-57.64,2.99-113.71,6.22-166.68,9.62-42.38,2.72-82.88,5.54-120.37,8.4-43.85,3.34-73.39,5.95-87.71,7.26Z"
          />
        </g>
      </g>
    </svg>    
  </div>
</template>

<script src="./course-page-svg.js"></script>
<style lang="scss" scoped src="./course-page-svg.scss"></style>